module.exports = __webpack_public_path__ + "img/Sara Polak.1bd2145d.jpg";